import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../Environment/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RgserviceService {
  basePath:string="";
  constructor(private http:HttpClient) { 
    this.basePath = environment.apiUrl;
  }
  public getRGSpecification1(request: any): Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'RG/GetSpecification', request, {
      headers,
      observe: 'response',
      responseType: 'json',
    });
  }
  public getRGSpecification(request: any): Observable<any>{
    const httpParams = new HttpParams({ fromObject: request });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'RG/GetSpecification', request, {
      params: httpParams,
      headers:headers,
      observe: 'response',
      responseType: 'json',
    });
  }
  public getRGLargerReducer(request:any): Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'RG/GetLargerReducer',request,{
      params:httpParams,
      headers:headers,
      observe:'response',
      responseType:'json'
    });
  }
  public getRGSmallerReducer(request:any): Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'RG/GetSmallerReducer',request,{
      params:httpParams,
      headers:headers,
      observe:'response',
      responseType:'json'
    });
  }
  // public getGearOrientation(size:any):Observable<any>{
  //   const url = `${this.basePath}HP/GetUnitVersion?size=${size}`;
  //   return this.http.get<any[]>(url).pipe(
  //     map((response: any) => response.value) // Extract and return the 'value' array
  //   );
  // }
  public getUnitVersion():Observable<any>{
    return this.http.get<any[]>(this.basePath + 'RG/GetUnitVersion');
  }
  public getTypeOfUnit(size:any):Observable<any>{
    const url = `${this.basePath}RG/GetTypeOfUnit?size=${size}`;
    return this.http.get<any[]>(url).pipe(
          map((response: any) => response) // Extract and return the 'value' array
    );
  }
  public getOutputShaft(size:any):Observable<any>{
    const url = `${this.basePath}RG/GetOutputShaft?size=${size}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response)
    );
  }
  public getAssemblyPosition(outputshaft:any):Observable<any>{
    const url = `${this.basePath}RG/GetAssemblyPosition?outputshaft=${outputshaft}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response)
    );
  }
  public getMotorAdaptor(typeOfUnit:any,size:any):Observable<any>{
    const url = `${this.basePath}RG/GetMotorAdaptor?typeOfUnit=${typeOfUnit}&size=${size}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response)
    );
  }
  public getSpecialfeature():Observable<any>{
    return this.http.get<any[]>(this.basePath + 'RG/GetSpecialfeature');
  }
}
